/* -----------------------------------------------------------------------
Custom Sign In Page
-----------------------------------------------------------------------
Links (ctrl + click to follow):
Contentful Entry: https://app.contentful.com/spaces/n3ohnvkomoi9/entries/7C0APhH6o2fuRE3Iy3tPIl
GraphQL Explorer: http://localhost:8000/__graphql?query=query%20MyQuery%20%7B%0A%20%20contentfulPageTemplateCustom(contentful_id%3A%20%7Beq%3A%20%227C0APhH6o2fuRE3Iy3tPIl%22%7D)%20%7B%0A%20%20%20%20heroHeader%0A%20%20%7D%0A%7D
-----------------------------------------------------------------------
Supported components: See "../components/solutions/index"
Slug: /...
-------------------------------------------------------------------------*/

import React from 'react';
import { graphql } from 'gatsby';
import HTMLWrapper from '../components/basic/HTMLWrapper';

import Layout from '../components/layout';
import Margin from '../components/basic/layouts/Section';
import Helmet from '../components/basic/Helmet';
import Text from '../components/basic/Text';

const Page = ({ location, data }) => {
	const content = data.contentfulPageTemplateCustom;

	return (
		<Layout location={location}>
			<Helmet
				pageTitle={content.metaTitle}
				description={content.metaDescription}
				location={location}
				updatedAt={content.updatedAt}
			/>
			<Margin>
				<Text component="h1">{content.heroHeader}</Text>
				<HTMLWrapper
					html={content.heroSubheaderLong.childMarkdownRemark.html}
				/>
			</Margin>
		</Layout>
	);
};

export default Page;

export const signInPageQuery = graphql`
	query signInPageQuery {
		contentfulPageTemplateCustom(
			contentful_id: { eq: "7C0APhH6o2fuRE3Iy3tPIl" }
		) {
			metaTitle
			metaDescription
			updatedAt
			heroHeader
			heroSubheaderLong {
				childMarkdownRemark {
					html
				}
			}
		}
	}
`;
